export default function getDoctorAvatarUrl({
  doctor,
  isLarge,
}: {
  doctor: {
    hide_avatar?: boolean
    square_avatar_small?: string
    square_avatar?: string
    dt_modified?: number
  }
  isLarge?: boolean
}) {
  if (doctor.hide_avatar) {
    return '/static/_v1/pd/icons/ui-kit/photo/no-avatar-with-text.svg'
  }

  const dtModifiedParam = doctor.dt_modified ? `?t=${doctor.dt_modified}` : ''

  if (doctor.square_avatar && isLarge) {
    return `${doctor.square_avatar}${dtModifiedParam}`
  }

  if (doctor.square_avatar_small) {
    return `${doctor.square_avatar_small}${dtModifiedParam}`
  }

  return '/static/_v1/pd/icons/ui-kit/photo/no-avatar.svg'
}
